import { UserInterface } from 'Interfaces'
import { Avatar } from 'antd'
import styles from './styles.module.scss'
import { UserOutlined } from '@ant-design/icons'

const UserCell = (name: string, record: UserInterface) => {
  const { identity_first_name, identity_last_name } = record

  if (!record.identity_uuid) return <div className={styles.userCell} />

  return (
    <div className={styles.userCell}>
      {!identity_first_name && !identity_last_name ? (
        <p>N/A</p>
      ) : (
        <p>
          {identity_first_name} {identity_last_name}
        </p>
      )}
    </div>
  )
}

export default UserCell
